<div class="loading-overlay" *ngIf="loadingService.loading$ | async">
    <tds-spinner size="lg" variant="standard"></tds-spinner>
</div>


